export default {
    excess: 'Fazla sorumluluk',
    security: 'Depozito',
    fuel_policy: 'Yakıt politikası',
    like_for_like: 'Bire bir değişim',
    full_to_full: 'Dolu dolu',
    mileage: 'Kilometre: Kiralama başına {mileage} mil',
    unlimited_mileage: 'Sınırsız kilometre',
    non_refundable: 'İade edilemez',
    free_cancellation_until: '{date} tarihine kadar ücretsiz iptal',
    cancellation_with_terms: 'İptal {0} şu şartlara uygun olarak',
    t_c_text: 'Şartlar ve Koşullar',
    two_free_extras: 'Teslimatta iki ücretsiz ek hizmet',
    glass_tyres_covered: 'Cam ve lastikler dahil',
    spec_fuel_petrol: 'benzin',
    spec_fuel_petrol_diesel: 'benzin/dizel',
};
